<template>
    <div id="credit-summary" class="m-4">
        <!-- TITLE -->
        <div class="vx-row mb-4">
            <div class="vx-col w-full lg:w-full">
                <vx-card class="mt-2" card-background="dark">
                    <h1 class="bold big-title m-0 text-white">
                        Expediente de <span class="success">riesgo crédito</span>.</h1>
                        <!--<vs-button @click.stop="previewTemplate()" class="success mt-2">Probar contratos</vs-button> -->
                </vx-card>
            </div>
        </div>
        <div v-if="isMounted">

            <!-- SUPPLIER RESTRICTION NOTIF -->
            <div v-if="source.supplier_id != null" class="vx-row">
                <div class="vx-col w-full">
                    <SupplierRestrictedData :source="source.supplier" />
                </div>
            </div>
            <!-- HEADER -->
            <div class="vx-row">
                <div class="vx-col sm:w-full md:w-5/12 mb-4">
                    <!-- detalle de proyecto -->
                    <div id="loan-detail" class="mb-4 vx-card p-6">
                        <div class="vx-row">
                            <div class="vx-col sm:w-full md:w-7/12">
                                <h5 class="success bold">{{ source.id }}</h5>
                                <h3 class="bold mb-0">{{ source.alias||"Sin alias" }}</h3>
                                <div v-if="project.pgm_potential_applicant">
                                    <vs-chip color="#f44336">
                                        <strong>{{ project.pgm_potential_applicant.program_info.name }}</strong>
                                    </vs-chip>
                                    <br><br>
                                </div> 
                                <p class="bold mb-2">
                                    {{ translatePersonalType(user_model.person_type) }} {{ hasPFAE }} |
                                    {{ translateCrowdfundingLoanType(source.finance.crowdfunding_loan_type) }} |
                                    {{ translateLoanType(source.finance.loan_type) }} |
                                    {{ translateProductType(source.finance.financial_product_id) }} |
                                </p>
                                <div class="flex">
                                    <p class="text-sm mb-0" v-if="!editLoanStep">
                                        Onboarding: <span class="bold">{{ source.loan_request_step||"--"  }}</span>
                                    </p>
                                    <div class="w-full" v-else>
                                        <vs-select
                                            class="w-full"
                                            v-model.lazy="stepSelected"
                                            label="Onboarding"
                                            name="stepSelected"
                                            placeholder="Seleccione una opción">
                                            
                                            <vs-select-item
                                                :key="index"
                                                :value="item.key"
                                                :text="item.value"
                                                v-for="(item,index) in step_options"
                                                class="w-full"
                                            />
                                        </vs-select>
                                    </div>
                                    <vs-button 
                                        v-if="!editLoanStep"
                                        @click.stop="editLoanStep = true" 
                                        icon-pack="feather" 
                                        icon="icon-edit" 
                                        color="success" 
                                        type="line" 
                                        style="margin: 1rem 0px 0px 5px"></vs-button>
                                    <vs-button 
                                        v-else
                                        @click.stop="requestUpdateLoanStep()" 
                                        icon-pack="feather" 
                                        icon="icon-save" 
                                        color="success" 
                                        type="line" 
                                        style="margin: 1.5rem 0px 0px 5px"></vs-button>
                                </div>
                                <a class="text-sm mb-4" href="https://docs.google.com/spreadsheets/d/1_P1FFJHGD7icuhXJ5Rlhl8cXhwvWCCLklw3rpPtgz3w/edit?usp=sharing" target="_blank">
                                    Consulta los pasos de onboarding y sus condiciones.
                                </a>
                                <div class="vx-row mt-4">
                                    <LoanGeolocationComponent
                                        :geolocation="project.geolocation_at_project_creation"/>
                                </div>
                            </div>
                            <div class="vx-col sm:w-full md:w-5/12 mt-4">
                                <span>Monto máximo permitido</span> <br>
                                <div class="flex justify-between mt-2">
                                    <span v-if="!editMaxAmount" class="bold text-2xl black">
                                        {{ costFormat(applicant.max_loan_amount_allowed_mxn) }}
                                    </span>
                                    <vs-input v-else 
                                        class="input" 
                                        v-money="money"
                                        v-model="newMaxAmamount"
                                        icon-pack="feather"
                                        icon="icon-dollar-sign" />

                                    <vs-button 
                                        v-if="!editMaxAmount"
                                        @click.stop="editMaxAmount = true" 
                                        icon-pack="feather" 
                                        icon="icon-edit" 
                                        color="success" 
                                        type="line" 
                                        style="margin-top: -1rem;"></vs-button>
                                    <vs-button 
                                        v-else
                                        @click.stop="updateMaxLoanAmountAllowed()" 
                                        icon-pack="feather" 
                                        icon="icon-save" 
                                        color="success" 
                                        type="line" 
                                        style="margin-top: 0rem;"></vs-button>
                                </div>
                            </div>
                        </div>
                        <vs-divider></vs-divider>
                        <loans-related-table ref="loansRelated" :relatedProjects="relatedProjects.running" />
                    </div>
                    <!-- <project-header v-if="isMounted" :relatedProjects="relatedProjects" :isNewPage="true"/> -->
                </div>
                <div class="vx-col sm:w-full md:w-7/12 mb-4">
                    <loan-status-dates :source="source"></loan-status-dates>
                </div>
            </div>
            <!-- DETAIL -->
            <div class="vx-row">
                <!-- DETALLE DE LA SOLICITUD -->
                <div v-if="isMounted" class="vx-col w-full mb-4">
                    <!-- SOLICITUD -->
                    <div class="vx-row">
                        <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3">
                            <!-- Solicitante de proyecto -->
                            <div id="applicant-detail" class="mb-4 vx-card p-2">
                                <vs-tabs>
                                    <vs-tab label="Solicitante">
                                        <ProfileDetail :source="source" :incomeSourcesData="incomeSources" :canEdit="canEdit" />
                                        <!-- cuentas de banco -->
                                        <vs-divider></vs-divider>
                                        <div id="cashing-data" class="mb-4 p-2">
                                            <BankAccountsDetail :source="source" />
                                        </div>
                                    </vs-tab>
                                    <vs-tab v-if="guaranteeRequired" :label="`Obligados solidarios: ${guarantees.length}`">
                                        <!-- <ProfileDetail :source="source" :incomeSourcesData="incomeSources" :guaranteeRequired="guaranteeRequired"/> -->
                                        <vs-tabs>
                                            <vs-tab size="small" :key="index" v-for="(guarantee, index) in guarantees" :label="`${getGuaranteeName(guarantee)}`">
                                                <!-- {{ guarantee }} -->
                                                <ProfileDetail 
                                                    :source="source" 
                                                    :incomeSourcesData="incomeSources" 
                                                    :guarantee="guarantee"
                                                    :guaranteeRequired="guaranteeRequired"
                                                    :canEdit="canEdit"/>
                                            </vs-tab>
                                        </vs-tabs>
                                    </vs-tab>
                                </vs-tabs>
                            </div>
                        </div>
                        <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3">
                            <!-- DETALLE DE PRÉSTAMO -->
                            <project-header 
                                class="mb-4" 
                                @on-show-amort-tab="onShowAmortTab"
                                @on-preapprove-request="onPreapproveRequest"
                                @on-approve-request="onApproveRequest"
                                v-if="isMounted" 
                                :relatedProjects="relatedProjects" 
                                :isNewPage="true"/>

                            <!-- INFORMACIÓN DE FINANCIAMIENTO  -->
                            <div id="finance-detail-card"  class="mb-4 vx-card p-2">
                                <finance-detail :source="source"></finance-detail>
                            </div>

                            <div v-if="source.finance.loan_type == 1">
                                <!-- Proveedor de proyecto -->
                                <div v-if="source.supplier_id != null" id="supplier-detail" class="mb-4 vx-card p-2">
                                    <div class="flex justify-between">
                                        <h6 class="success bold">PROVEEDOR</h6>
                                        <project-supplier-selector
                                            :isFromFolder="true"
                                            :supplier.sync="source.supplier"
                                            :project_id="source.id"></project-supplier-selector>
                                    </div>
                                    <vs-list>
                                        <vs-list-item title="SID">
                                            <div @click.stop="handleSelected(supplier)" class="success clickable">{{ supplier.id }}</div>
                                        </vs-list-item>
                                        <vs-list-item title="Nombre comercial">{{ supplier.tradename }}</vs-list-item>
                                        <template v-if="supplier_agent != null">
                                            <vs-list-item title="Agente">{{ supplier_agent.name }}</vs-list-item>
                                            <vs-list-item v-if="supplier_agent.phone != null" title="Tel.">{{ supplier_agent.phone.country_calling_code }} {{ phoneFormat(supplier_agent.phone.phone) }}</vs-list-item>
                                            <vs-list-item title="Email">{{ supplier_agent.user.email }}</vs-list-item>
                                        </template>
                                        <template v-else>
                                            <vs-list-item title="Agente">No asignado</vs-list-item>
                                        </template>
                                    </vs-list>
                                    <vs-divider></vs-divider>
                                    <due-portfolio-supplier-stats
                                        :realTime="true"
                                        :supplierId="source.supplier.id"/>
                                </div>
                                <div v-else class="mb-4 vx-card p-2">
                                    <div class="flex justify-between">
                                        <h6 class="success bold">PROVEEDOR</h6>
                                        <vs-button 
                                        size="small" 
                                        color="warning" 
                                        type="line" 
                                        class="mb-1"
                                        @click.stop="showFormPromptSupplierAssignment = true">
                                            Asignar proveedor
                                        </vs-button>
                                    </div>
                                    <vs-list>
                                        <vs-list-item title="SID">No asignado</vs-list-item>
                                        <vs-list-item title="Nombre comercial">No asignado</vs-list-item>
                                        <vs-list-item title="Agente">No asignado</vs-list-item>
                                    </vs-list>
                                </div>
                            </div>
                            <!-- cobranza -->
                            <div id="cashing-data" class="mb-4 vx-card p-2">
                                <CashingDetail :source="source" />
                            </div>
                        </div>
                        <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3">
                            <!-- EVENTOS DEL CRÉDITO -->
                            <div id="credit-events" class="mb-4 vx-card p-2">
                                <credit-events-log ref="creditEvents" :projectId="source.id" />
                            </div>
                            <!-- BITÁCORA -->
                            <div id="message-logger" class="mb-4 vx-card p-2">
                                <project-message-logger class="mt-4"></project-message-logger>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- COMPONENTS -->
            <div class="vx-row">
                <div class="vx-col w-full">
                    <project-detail :id="source.id" ref="project_main" variant="risk-model"></project-detail>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="vx-row">
                <div class="vx-col w-1/4 mb-4">
                    <vx-card class="h-64">
                    </vx-card>
                </div>
                <div class="vx-col w-3/4 mb-4">
                    <vx-card class="h-64">
                    </vx-card>
                </div>
                <div class="vx-col w-1/3 mb-4">
                    <vx-card class="h-64">
                    </vx-card>
                </div>
                <div class="vx-col w-1/3 mb-4">
                    <vx-card class="h-64">
                    </vx-card>
                </div>
                <div class="vx-col w-1/3 mb-4">
                    <vx-card class="h-64">
                    </vx-card>
                </div>
                <div class="vx-col w-3/5 mb-4">
                    <vx-card class="h-64">
                    </vx-card>
                </div>
                <div class="vx-col w-2/5 mb-4">
                    <vx-card class="h-64">
                    </vx-card>
                </div>
            </div>
        </div>


        <vs-popup v-if="showFormPromptSupplierAssignment" id="supplier-assignment" title="Asignar un proveedor" :active.sync="showFormPromptSupplierAssignment">
            <LoanSupplierSelector 
                :loan="source"
                @updated="supplierAssgined"
                ></LoanSupplierSelector>
        </vs-popup>

    </div>
</template>

<script>
import ExtraDocuments from "@components/projectsv3/components/ExtraDocuments.vue";
import LoanData from "@components/projectsv3/components/LoanData.vue";
import LoanDetail from "./components/LoanDetail.vue";
import CreditEventsLog from "@components/projectsv2/CreditEventsLog";
import ProjectMessageLogger from "@components/ProjectMessageLogger";
// import ProjectLifeCycle from "@components/project-details/ProjectLifeCycle.vue";
import LoanStatusDates from "./components/LoanStatusDates.vue";
import CashingDetail from "./components/CashingDetail.vue";
import BankAccountsDetail from "./components/BankAccountsDetail.vue";
import DuePortfolioSupplierStats from "@components/supplier/DuePortfolioSupplierStats";
import LoansRelatedTable from "./components/LoansRelatedTable.vue";
import ProfileDetail from "./components/ProfileDetail.vue";
import ProjectDetail from "@views/admin/projectsv2/ProjectDetail.vue";
import FinanceDetail from "./components/FinanceDetail.vue";
import LoanSupplierSelector from "./components/LoanSupplierSelector.vue";

import formatHelper from "@mixins/formatHelper";
import projectStatusHelper from "@mixins/projectStatusesHelper.js"
import {mapActions, mapMutations, mapState} from "vuex";
import { VMoney } from 'v-money'

import ProjectHeader from "@components/project-details/ProjectHeader.vue";
import ProjectSupplierSelector from "../../../../../src/components/project-details/ProjectSupplierSelector.vue";

import LoanGeolocationComponent from "../../../../components/projectsv2/components/LoanGeolocationComponent.vue";


const requiredObjects = [
    'amortizations',
    'contracts',
    'finance.guarantees.personal',
    'finance.guarantees.personal.phone',
    'finance.guarantees.personal.address',
    'finance.guarantees.personal.creditProfile',
    'finance.guarantees.personal.occupation',
    'finance.guarantees.personal.identityVerifications',
    'finance.guarantees.business.address',
    'finance.guarantees.business.phone',
    'finance.guarantees.business.creditProfile',
    'finance.guarantees.business.personal.phone',
    'finance.guarantees.business.personal.address',
    'finance.guarantees.business.personal.occupation',
    'finance.guarantees.business.personal.identityVerifications',
    'finance.guarantee.guaranteeProfile.personal.phone',
    'finance.guarantee.guaranteeProfile.personal.occupation',
    'finance.guarantee.guaranteeProfile.business.phone',
    'finance.guarantee.guaranteeProfile.personal.creditProfile',
    'finance.guarantee.guaranteeProfile.personal.address',
    'finance.guarantee.guaranteeProfile.business.creditProfile',
    'finance.guarantee.guaranteeProfile.business.address',
    'finance.guarantee.guaranteeProfile.business.personal.phone',
    'finance.guarantee.guaranteeProfile.business.personal.occupation',
    'finance.guarantee.guaranteeProfile.business.personal.identityVerifications',

    'finance.owner.guaranteeProfile',
    'finance.owner.guaranteeProfile.personal.occupation',
    'finance.owner.guaranteeProfile.personal.identityVerifications',
    'finance.owner.guaranteeProfile.business',

    'client.user.business.ownerBusinessProfile',
    'client.user.business.ownerBusinessProfile.address',
    'client.user.business.ownerBusinessProfile.creditProfile',
    'client.user.business.ownerBusinessProfile.personal',
    'client.user.business.ownerBusinessProfile.personal.occupation',
    'client.user.business.ownerBusinessProfile.phone',
    'client.user.business.ownerPersonalProfile',
    'client.user.business.ownerPersonalProfile.address',
    'client.user.business.ownerPersonalProfile.creditProfile',
    'client.user.business.ownerPersonalProfile.phone',

    'relatedProfiles',
    'client.user.personal.address',
    'client.user.personal.creditProfile',
    'client.user.personal',
    'client.user.personal.occupation',
    'client.user.personal.bankAccounts',
    'client.user.personal.phone',
    'client.user.personal.identityVerifications',

    'client.kycProfile',

    'client.user.business.address',
    'client.user.business.personal.address',
    'client.user.business.personal.creditProfile',
    'client.user.business.personal',
    'client.user.business.personal.occupation',
    'client.user.business.personal.identityVerifications',
    'client.user.business.personal.phone',
    'client.user.business.country',
    'client.user.business.businessActivity',
    'client.user.business',
    'client.user.business.creditProfile',
    'client.user.business.bankAccounts',
    'client.user.business.phone',
    'splits',
    'supplier.user',
    'agent',
    'agent.user',
    'agent.phone',
    'projectFgLocations',
    'pgmPotentialApplicant'
    // 'client.user.personal.creditProfile.address',
];

const VEHICLE_FAMILY_GROUP_ID = 7;

const PF_LOAN_OPTIONS = [
    { key: 'pfae_0_sat_link', value: "pfae_0_sat_link (syntage)" },
    { key: 'pf_1_applicant_address', value: "pf_1_applicant_address" },
    { key: 'pf_2_tech_address', value: "pf_2_tech_address" },
    { key: 'pf_3_loan_profile', value: "pf_3_loan_profile" },
    { key: 'pf_4_occupation', value: "pf_4_occupation" },
    { key: 'pf_5_job_profile', value: "pf_5_job_profile" },
    { key: 'pf_7_expenses', value: "pf_7_expenses" },
    { key: 'pf_8_loan_checkpoint', value: "pf_8_loan_checkpoint" },
    { key: 'pf_10_credit_acceptance', value: "pf_10_credit_acceptance" },
    { key: 'pf_11_guarantee_data', value: "pf_11_guarantee_data" },
    { key: 'pf_12_documents_and_identity', value: "pf_12_documents_and_identity" }
];
const PM_LOAN_OPTIONS = [
    { key: 'pm_2_business_address_confirmation', value: "pm_2_business_address_confirmation" },
    { key: 'pm_legal_rep_information', value: "pm_legal_rep_information" },
    { key: 'pm_3_personal_profile_address', value: "pm_3_personal_profile_address" },
    { key: 'pm_4_personal_profile_curp', value: "pm_4_personal_profile_curp" },
    { key: 'pm_5_personal_profile_sic_check', value: "pm_5_personal_profile_sic_check" },
    { key: 'pm_7_business_stakeholders', value: "pm_7_business_stakeholders" },
    { key: 'pm_8_personal_guarantees_confirmation', value: "pm_8_personal_guarantees_confirmation" },
    { key: 'pm_9_documents_and_identity', value: "pm_9_documents_and_identity" }
];

export default {
    name: "CreditSummary",
    mixins: [formatHelper, projectStatusHelper],
    directives: { money: VMoney },
    components: {
        ExtraDocuments,
        LoanData,
        LoanDetail,
        CreditEventsLog,
        ProjectMessageLogger,
        LoanStatusDates,
        CashingDetail,
        BankAccountsDetail,
        DuePortfolioSupplierStats,
        LoansRelatedTable,
        ProjectHeader,
        ProfileDetail,
        ProjectDetail,
        ProjectSupplierSelector,
        FinanceDetail,
        LoanSupplierSelector,
        LoanGeolocationComponent
        // ProjectLifeCycle
    },
    props: {
        id: String|Number
    },
    data: () => ({
        isMounted: false,
        source: null,
        incomeSources: [],
        relatedProjects: [],
        editMaxAmount: false,
        editLoanStep: false,
        newMaxAmamount: null,
        showFormPromptSupplierAssignment: false,
        money: {
            decimal: '.',
            thousands: ',',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: false
        },
        PF_LOAN_OPTIONS: PF_LOAN_OPTIONS,
        PM_LOAN_OPTIONS: PM_LOAN_OPTIONS,
        stepSelected: null,
    }),
    async mounted() {
        await this.getProjectData();
        window.document.title = `PID: ${this.id} - Riesgo`;
        this.stepSelected = this.source.loan_request_step;
    },
    computed:  {
        ...mapState('projects', ['project']),
        isMoral() {
            return this.source.client.user.person_type == 0;
        },
        user_model() {
            return this.source.client.user;
        },
        supplier() {
            return this.source.supplier;
        },
        supplier_agent() {
            return this.source.supplier_agent_id != null ? this.source.agent : null;
        },
        applicant() {
            return this.source.client;
        },
        finance() {
            return this.source.finance;
        },
        personal() {
            return this.source.client.user.personal;
        },
        business() {
            return this.source.client.user.business;
        },
        address() {
            if(this.isMoral) {
                return this.business.address;
            } else {
                return this.personal.address;
            }
        },
        applicantName() {
            if(this.isMoral) {
                return this.business.name
            }
        },
        profileId() {
            if(this.isMoral) {
                return this.business.id;
            } else {
                return this.personal.id;
            }
        },
        mainRole() {
            if(this.isMoral) {
                return "pm_income_source";
            } else {
                return "pf_income_source";
            }
        },
        mainIncomeSource() {
            return this.incomeSources[0];
        },
        guaranteeRequired() {
            return this.finance.guarantee_required == 1;
        },
        guarantees() {
            return this.finance.guarantees;
        },
        step_options() {
            if(this.isMoral) {
                return this.PM_LOAN_OPTIONS;
            } else {
                return this.PF_LOAN_OPTIONS;
            }
        },
        canEdit() {
            return true;
        },
        hasPFAE() {
            if(!this.isMoral) {
                return this.personal.tax_profile == 1 ? "con Actividad Empresarial" :  "";
            }

            return "";
        }
    },
    methods: {
        ...mapActions('projects', ['getProject']),
        ...mapMutations('projects', ['setProject']),
        async onPreapproveRequest() {
            let main = this.$refs.project_main;
            await main.preapproveRequest();
        },
        async onApproveRequest() {
            let main = this.$refs.project_main;
            await main.approveRequest();
        },
        onShowAmortTab() {
            this.$refs.project_main.showAmortTable();
        },
        async getProjectData() {
            try {
                this.showLoading(true);
                let params = "with[]=" + requiredObjects.join("&with[]=");
                let response = await axios.get(`/api/v2/projects/${this.id}?${params}`);
                this.source = response.data;
                await this.getIncomeSourcesForApplicant(this.profileId, this.mainRole);
                await this.getProjectsRelated();
                this.setProject(this.source);
                this.currentSupplierId = this.source.supplier_id;
                this.isMounted = true;
                this.showLoading(false);
            } catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        async getIncomeSourcesForApplicant(profileId, role){
            try{
                let res = await axios.get(`/api/v1/forms/${profileId}/${role}/getProfileIncomeSources`);
                this.incomeSources = res.data;
            } catch (error) {
                console.log(error);
            }
        },
        async getProjectsRelated() {
            try {
                const res = await axios.get(`/api/v2/projects/${this.id}/getProjectsRelated`);
                this.relatedProjects = res.data;
            } catch (e) {
                this.warn(e);
            }
        },
        async updateMaxLoanAmountAllowed () {
            this.showLoading(true, "Actualizando monto máximo permitido...");
            try {
                await axios.put('/api/v1/applicant/' + this.applicant.id, {
                    max_loan_amount_allowed_mxn: parseFloat(this.newMaxAmamount.replaceAll(",", ""))
                })
                this.editMaxAmount = false;
                this.applicant.max_loan_amount_allowed_mxn = this.newMaxAmamount.replaceAll(",", "");
                this.newMaxAmamount = null;
                this.showLoading(false);
            } catch (error) {
                console.log(error)
                this.showLoading(false);
            }
            this.showLoading(false);
        },
        async handleSelected(supplier) {
            window.open(`/suppliers/${supplier.id}`, '_blank');
        },
        isVehicleLoan() {
            let flag = false;
            if(this.source.finance.loan_type == 1) { // Sí es automotriz
                let fg_location = this.source.project_fg_locations[0];
                if(fg_location && fg_location.family_group_id == VEHICLE_FAMILY_GROUP_ID) {
                    flag = true;
                }
            }
            return flag;
        },
        getGuaranteeName(guarantee) {
            try {
                if(guarantee.personal_profile_id != null) {
                    const personal = guarantee.personal;
                    return `${personal.first_name} ${personal.last_name_1}`;
                } else {
                    const business = guarantee.business;
                    return business.name;
                }
            } catch (error) {
                console.log(error);
                return "NA";
            }
        },
        supplierAssgined()
        {
            this.showFormPromptSupplierAssignment = false;
            this.getProjectData();
        },
        requestUpdateLoanStep() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: 'Actualizar step de solicitud',
                text: `¿Estás seguro de actualizar el paso de solicitud a ${this.stepSelected}?`,
                acceptText: 'Aceptar',
                accept: this.doUpdateLoanStep,
                cancelText: 'Cancelar',
                cancel: false
            });
        },
        async doUpdateLoanStep() {
            try {
                this.showLoading(true, "Actualizando paso de solicitud...");
                await axios.put(`/api/loan/put/update-loan-step`, {
                    step: this.stepSelected,
                    loan_id: this.source.id
                });
                this.editLoanStep = false;
                this.showLoading(false);
                await this.getProjectData();
                this.saveSuccessNotif();
            } catch (error) {
                console.log(error);
                this.failedOperationNotif();
            }
        },
        async previewTemplate(){
            const url = `${this.ApiDomain}/api/test-contracts?access_token=${this.AccessToken}`
            window.open(url,url,'addressbar=0,directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=0,resizable=0');
        },
    }
}
</script>

<style>
.money-card {
    /* background-color: #2d2d2d; */
    color: #2d2d2d;
    /* padding: 1rem; */
    /* border-radius: 10px; */
    width: 45%;
}
</style>
